/**
 * Email queue configuration constants
 */

/** Firestore collection names */
export const EMAIL_QUEUE_COLLECTIONS = {
  JOBS: "emailQueueJobs",
  STATS: "emailQueueStats",
  STATUS: "emailQueueStatus",
} as const;

/** Rate limiting configuration */
export const RATE_LIMITING = {
  /** Maximum requests per second to Resend API */
  MAX_REQUESTS_PER_SECOND: 2,
  
  /** Minimum delay between requests in milliseconds */
  MIN_DELAY_BETWEEN_REQUESTS: 500, // 500ms = 2 req/sec
  
  /** Maximum jobs to process in a single function execution */
  MAX_JOBS_PER_EXECUTION: 10,
  
  /** How often the processor function should run (seconds) */
  PROCESSOR_SCHEDULE_INTERVAL: 30,
} as const;

/** Retry configuration */
export const RETRY_CONFIG = {
  /** Default maximum attempts for a job */
  DEFAULT_MAX_ATTEMPTS: 5,
  
  /** Exponential backoff multiplier */
  BACKOFF_MULTIPLIER: 2,
  
  /** Base delay for first retry (seconds) */
  BASE_RETRY_DELAY: 60,
  
  /** Maximum retry delay (seconds) */
  MAX_RETRY_DELAY: 3600, // 1 hour
} as const;

/** Job priorities */
export const JOB_PRIORITIES = {
  HIGH: 1,
  NORMAL: 5,
  LOW: 10,
} as const;

/** Queue health thresholds */
export const HEALTH_THRESHOLDS = {
  /** Consider queue unhealthy if failure rate exceeds this percentage */
  MAX_FAILURE_RATE: 10,
  
  /** Consider queue backlogged if pending jobs exceed this number */
  MAX_PENDING_JOBS: 1000,
  
  /** Expected average processing time per job (milliseconds) */
  TARGET_PROCESSING_TIME: 2000,
} as const;